import { useEffect, useState } from "react";
import { Table } from "react-bootstrap";
import franchiseAdminAPI from "../../api/franchiseAdminAPI";
import Pagination from "../../components/Pagination";

const BusinessCustomers = ({ franchiseId }) => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  useEffect(() => {
    if (franchiseId) {
      fetchData();
    }
  }, [franchiseId]);

  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await franchiseAdminAPI.getAllCustomers(
        franchiseId,
        page,
        pageSize,
      );

      const data = res.data?.customers?.content || [];
      setCustomers(data);
      setTotalPages(res.data?.customers?.totalPages || 0);
      setLoading(false);
    } catch (err) {
      console.error(err);
      setCustomers([]);
      setTotalPages(0);
      setLoading(false);
    }
  };
  const handlePageSizeChange = (e) => {
    const size = parseInt(e.target.value);
    setPageSize(size);
    setPage(0);
  };

  const handlePageClick = (data) => {
    const selectedPage = Math.max(0, Math.min(data.selected, totalPages - 1));
    setPage(selectedPage);
    localStorage.setItem("franchise-level1", selectedPage);
  };
  return (
    <div className="mt-3">
      {loading && <p>Loading...</p>}

      {!loading && customers.length === 0 && <p>No customers found</p>}

      {!loading && customers.length > 0 && (
        <div className="table-responsive">
          <Table striped bordered hover>
            <thead>
              <tr>
                <th>#</th>
                <th>User Name</th>
                <th>Email</th>
                <th>Country</th>
                <th>Franchise</th>
                <th>Contact</th>
              </tr>
            </thead>

            <tbody>
              {customers.map((c, index) => (
                <tr key={c.userId}>
                  <td>{index + 1}</td>
                  <td>{c.userName}</td>
                  <td>{c.userEmail}</td>
                  <td>{c.countryName}</td>
                  <td>{c.organization} - {c.location}</td>
                  <td>{c.managedBy}</td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      )}
      <div style={{ marginTop: "auto" }}>
        {customers.length > 0 && totalPages > 0 && (
          <Pagination
            page={page}
            pageSize={pageSize}
            totalPages={totalPages}
            handlePageSizeChange={handlePageSizeChange}
            handlePageClick={handlePageClick}
          />
        )}
      </div>
    </div>
  );
};

export default BusinessCustomers;
